import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModeloVeiculoTipoDespesaService {
  private data = null;
	private url = environment.serviceApi;
  constructor(public http: Http) { }


  getModeloVeiculoTipoDesepesa(modeloVeiculoid) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/modelosveiculotipodespesa/' + modeloVeiculoid)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaModeloVeiculoTipoDesepesa(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/modelosveiculotipodespesa', {
				modelo_veiculo_id: 				data.modeloId,
				tipo_despesa_id: 				data.despesa,
				quilometragem_previsao: 		data.kmPrevisao,
				intervalo_meses_previsao: 		data.tempoPrevisao,
				sequencia: 						data.sequencia
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	limpaModeloVeiculoTipoDesepesa(modeloVeiculoid){
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/modelosveiculotipodespesa/' + modeloVeiculoid)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}